export * from './lib/back-office-auth-feature-shell.module';
